import React from 'react'
import { BoySeat, GirlSeat, Steering } from '../../../../assests/ExportImageIcon'
import './busSeatSelection.css'

// Static placeholder — no seat-availability API exists yet, so the whole seat
// map below is a hardcoded mock matching the reference design (deck layout,
// booked/gendered seats, the one pre-selected seat). Once a bus API exists,
// this can be wired up for real. Content only (no tab bar) — rendered by
// SeatBookingPanel.jsx alongside the SELECT SEAT tab.
const DECK_SEAT_LAYOUT = [
    { num: '1', cells: ['available', 'available', 'available', 'gap', 'available', 'available'] },
    { num: '2', cells: ['available', 'booked', 'booked', 'available', 'booked', 'booked'] },
    { num: '3', cells: ['available', 'available', 'available', 'available', 'available', 'available'] },
    { num: '4', cells: ['available', 'booked', 'selected', 'available', 'available', 'booked'] },
    { num: '5-6', tall: true, cells: ['booked', 'booked', 'gap', 'booked', 'booked', 'gap'] },
    { num: '7-8', tall: true, cells: ['booked', 'booked', 'gap', 'booked', 'booked', 'gap'] },
    { num: '9', cells: ['female', 'booked', 'gap', 'female', 'booked', 'gap'] },
    { num: '10', cells: ['male', 'male', 'gap', 'gap', 'gap', 'male'] },
    { num: '11', cells: ['gap', 'gap', 'gap', 'gap', 'gap', 'male'] },
]

const SELECTED_SEAT = { label: 'C4', price: '₹6,012' }

const SeatCell = ({ status, tall }) => {
    if (status === 'gap') {
        return <span className={`seat seat--gap ${tall ? 'seat--tall' : ''}`} />
    }
    if (status === 'selected') {
        return (
            <span className={`seat seat--selected ${tall ? 'seat--tall' : ''}`}>
                <span className='seat__tooltip'>{SELECTED_SEAT.label} <span>{SELECTED_SEAT.price}</span></span>
            </span>
        )
    }
    if (status === 'female' || status === 'male') {
        return (
            <span className={`seat seat--booked ${tall ? 'seat--tall' : ''}`}>
                <img className='seat__genderIcon' src={status === 'female' ? GirlSeat : BoySeat} alt="" />
            </span>
        )
    }
    return <span className={`seat seat--${status} ${tall ? 'seat--tall' : ''}`} />
}

const SeatDeck = ({ name, showDriverCabin }) => (
    <div className='seatDeck'>
        <div className='seatDeck__head'>
            <div className='seatDeck__name'>{name}</div>
            {showDriverCabin && (
                <div className='seatDeck__driver'>
                    Driver Cabin
                    <span className='seatDeck__driverIcon'>
                        <img src={Steering} alt="" />
                    </span>
                </div>
            )}
        </div>

        <div className='seatCols'>
            <span />
            {['A', 'B', 'C'].map((c) => <span className='seatCols__label' key={c}>{c}</span>)}
            <span />
            {['D', 'E', 'F'].map((c) => <span className='seatCols__label' key={c}>{c}</span>)}
        </div>

        {DECK_SEAT_LAYOUT.map((row) => (
            <div className='seatRow' key={row.num}>
                <span className='seatRow__num'>{row.num}</span>
                <SeatCell status={row.cells[0]} tall={row.tall} />
                <SeatCell status={row.cells[1]} tall={row.tall} />
                <SeatCell status={row.cells[2]} tall={row.tall} />
                <span />
                <SeatCell status={row.cells[3]} tall={row.tall} />
                <SeatCell status={row.cells[4]} tall={row.tall} />
                <SeatCell status={row.cells[5]} tall={row.tall} />
            </div>
        ))}

        <div className='seatDeck__legend'>
            <span className='seatLegendItem'>
                <span className='seatLegendItem__swatch' />
                Book Any
            </span>
            <span className='seatLegendItem'>
                <img className='seat__genderIcon seat__genderIcon--legend' src={GirlSeat} alt="" />
                Female Only
            </span>
            <span className='seatLegendItem'>
                <img className='seat__genderIcon seat__genderIcon--legend' src={BoySeat} alt="" />
                Male Only
            </span>
            <span className='seatLegendItem'>
                <span className='seatLegendItem__swatch seatLegendItem__swatch--booked' />
                Booked
            </span>
        </div>
    </div>
)

const SeatSelectionPanel = ({ onContinue }) => (
    <div className='seatSelectPanel'>
        <div className='seatSelectPanel__title'>Select Seat</div>

        <div className='seatDeckRow'>
            <SeatDeck name='Lower Deck' showDriverCabin />
            <SeatDeck name='Upper Deck' />
        </div>

        <div className='seatSelectPanel__footer'>
            <div>
                <div className='seatSelectPanel__footerPrice'>₹1,600</div>
                <div className='seatSelectPanel__footerSeats'>2 Seats</div>
            </div>
            <button type='button' className='commonBtn seatSelectPanel__footerBtn' onClick={onContinue}>
                Select Boarding/Drop Points
            </button>
        </div>
    </div>
)

export default SeatSelectionPanel
